module.exports = __webpack_public_path__ + "img/service-audit-1.b9b9c203.png";